import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col, Form, Card, Button, Breadcrumb, Table, Pagination, Badge, Modal } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { createCompensatoryLeave, updateCompensatoryLeave, getAllCompensatoryLeaves, getCompLeaveDocument } from "../../../../api/onboarddeboard";
const fmtDate = (d) => {
  if (!d) return "-";
  const dt = new Date(d);
  if (isNaN(dt)) return d;
  const dd = String(dt.getDate()).padStart(2, "0");
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  const yyyy = dt.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

// Formats a Date using its LOCAL year/month/day (avoids the UTC roll-back
// that toISOString() causes in timezones ahead of UTC, e.g. IST).
const formatLocalDate = (d) => {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};
const getWorkDetailsError = (value) => {
    const trimmedValue = value.trim();

    if (/^\s+$/.test(value)) {
        return "Work details cannot be only spaces.";
    }
    if (!trimmedValue) {
        return "Work details are mandatory.";
    }
    if (/^\d+$/.test(trimmedValue)) {
        return "Work details cannot be only numeric.";
    }
    if (/^[^a-zA-Z0-9]+$/.test(trimmedValue)) {
        return "Work details cannot be only special characters.";
    }
    if (
        /^[^a-zA-Z]*$/.test(trimmedValue) &&
        /[0-9]/.test(trimmedValue) &&
        /[^a-zA-Z0-9]/.test(trimmedValue)
    ) {
        return "Work details cannot be only numbers and special characters.";
    }
    if (trimmedValue.length > 500) {
        return "Work details cannot exceed 500 characters.";
    }
    return "";
};
const ITEMS_PER_PAGE = 20;

const CompensatoryLeaveRequest = () => {
  const token = localStorage.getItem("token");

  const [workingDate, setWorkingDate] = useState("");
  const [workDetails, setWorkDetails] = useState("");
  const [documentFile, setDocumentFile] = useState(null);
  const [documentPreview, setDocumentPreview] = useState("");
  const [existingDocumentName, setExistingDocumentName] = useState("");
  const [errors, setErrors] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [applicationData, setApplicationData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [sortField, setSortField] = useState("applyDate");
  const [currentPage, setCurrentPage] = useState(1);

  const [showEditWarningModal, setShowEditWarningModal] = useState(false);
  const [pendingEditApplication, setPendingEditApplication] = useState(null);

  const [showDocModal, setShowDocModal] = useState(false);
  const [docUrl, setDocUrl] = useState(null);
  const [docType, setDocType] = useState("");

  const [showWorkModal, setShowWorkModal] = useState(false);
  const [workDetailsText, setWorkDetailsText] = useState("");

  const fetchApplications = useCallback(() => {
    setIsLoading(true);
    getAllCompensatoryLeaves(token)
      .then((r) => setApplicationData(r.data || []))
      .catch(() => toast.error("Error loading compensatory leave requests."))
      .finally(() => setIsLoading(false));
  }, [token]);

  useEffect(() => { if (token) fetchApplications(); }, [token, fetchApplications]);

  const validate = () => {
    const newErrors = {};
    if (!workingDate) newErrors.workingDate = "Working date is required.";
    const workDetailsError = getWorkDetailsError(workDetails);
    if (workDetailsError) newErrors.workDetails = workDetailsError;
    return newErrors;
};

  const handleDocumentChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const allowedTypes = ["application/pdf", "image/jpeg", "image/jpg", "image/png"];
    if (!allowedTypes.includes(file.type)) { toast.error("Only PDF, JPG and PNG files are allowed."); e.target.value = null; return; }
    if (file.size > 1024 * 1024) { toast.error("File size should not exceed 1MB."); e.target.value = null; return; }
    setDocumentFile(file);
    setDocumentPreview(file.name);
  };

  const handleRemoveDocument = () => {
    setDocumentFile(null); setDocumentPreview("");
    const fileInput = document.getElementById("compDocumentUpload");
    if (fileInput) fileInput.value = null;
  };

  const handleViewDocument = async (id) => {
    try {
      const res = await getCompLeaveDocument(id, token);
      setDocUrl(URL.createObjectURL(res.data));
      setDocType(res.data.type);
      setShowDocModal(true);
    } catch {
      toast.error("Failed to load document.");
    }
  };
  const closeDocModal = () => { if (docUrl) URL.revokeObjectURL(docUrl); setDocUrl(null); setDocType(""); setShowDocModal(false); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validate();
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    const formData = new FormData();
    formData.append("workingDate", workingDate);
    formData.append("workDetails", workDetails.trim());
    if (documentFile) formData.append("file", documentFile);

    setIsSubmitting(true);
    try {

  if (isEditMode) {

    await updateCompensatoryLeave(editId, formData, token);

    toast.success("Compensatory leave request updated successfully!");

  } else {

    const duplicateExists = applicationData.some(
      (item) => item.workingDate === workingDate
    );
    

    await createCompensatoryLeave(formData, token);

    toast.success("Compensatory leave request created successfully!");
  }

  await fetchApplications();
  handleCancel();

} catch (error) {
 console.log("FULL ERROR:", error);
  console.log("STATUS:", error?.response?.status);
  console.log("RESPONSE DATA:", error?.response?.data);

  const errorMessage =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    (typeof error?.response?.data === "string"
      ? error.response.data
      : null) ||
    error?.message ||
    `Failed to ${isEditMode ? "update" : "create"} compensatory leave request.`;

  toast.error(errorMessage);

} finally {
  setIsSubmitting(false);
}
  };

  const handleEdit = (application) => {
    if (application.status !== "PENDING") { setPendingEditApplication(application); setShowEditWarningModal(true); }
    else applyEdit(application);
  };

  const applyEdit = (app) => {
    setIsEditMode(true);
    setEditId(app.id);
    setWorkingDate(app.workingDate || "");
    setWorkDetails(app.workDetails || "");
    setExistingDocumentName(app.documentName || "");
    setDocumentFile(null); setDocumentPreview(""); setErrors({});
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleCancel = () => {
    setWorkingDate(""); setWorkDetails(""); setDocumentFile(null); setDocumentPreview("");
    setExistingDocumentName(""); setIsEditMode(false); setEditId(null); setErrors({});
    const fileInput = document.getElementById("compDocumentUpload");
    if (fileInput) fileInput.value = null;
  };

  const handleExportCSV = () => {
    const headers = ["Working Date", "Applied On", "Work Details", "Status"];
    let csv = headers.join(",") + "\n";
    filteredData.forEach((item) => {
      csv += [item.workingDate, item.applyDate, item.workDetails, item.status].map((c) => `"${c ?? ""}"`).join(",") + "\n";
    });
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `compensatory-leave-${new Date().toISOString().split("T")[0]}.csv`;
    a.click(); URL.revokeObjectURL(url);
  };

  const getStatusBadge = (s) => {
    const map = { PENDING: "warning", APPROVED: "success", REJECTED: "danger" };
    return <Badge bg={map[s] || "secondary"}>{s}</Badge>;
  };

  let filteredData = [...applicationData];
  if (searchQuery.trim()) {
    const q = searchQuery.toLowerCase();
    filteredData = filteredData.filter((item) => (item.workingDate || "").toLowerCase().includes(q) || (item.workDetails || "").toLowerCase().includes(q));
  }
  if (statusFilter !== "all") filteredData = filteredData.filter((item) => item.status === statusFilter);
  if (sortField === "applyDate") filteredData.sort((a, b) => new Date(b.applyDate) - new Date(a.applyDate));
  else if (sortField === "workingDate") filteredData.sort((a, b) => new Date(b.workingDate) - new Date(a.workingDate));
  else if (sortField === "status") filteredData.sort((a, b) => a.status.localeCompare(b.status));

  const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);
  const paginated = filteredData.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);
  const errStyle = { color: "red", fontSize: 13, marginTop: 3 };

  return (
    <Container fluid className="p-4">
      <style>{`
        .lc-breadcrumb a { text-decoration: none !important; color: #2E5CB8 !important; }
        .lc-breadcrumb .breadcrumb-item.active { color: #6c757d !important; }
        .pagination .page-item.active .page-link { background-color: #2E5CB8 !important; border-color: #2E5CB8 !important; }
      `}</style>
      <ToastContainer position="top-right" autoClose={3000} />

      <h4 className="page-main-heading" style={{ marginBottom: 12 }}>Compensatory Leave Request</h4>
      <Breadcrumb className="lc-breadcrumb">
        <Breadcrumb.Item href="#">Leave</Breadcrumb.Item>
        <Breadcrumb.Item href="#">Leave Application</Breadcrumb.Item>
        <Breadcrumb.Item active>Compensatory Leave Request</Breadcrumb.Item>
      </Breadcrumb>

      <Row className="mb-4">
        <Col xl={12}>
          <Card>
            <Card.Body>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Row className="mb-3">
                      <Form.Label className="col-sm-3 col-form-label form-label">Working Date<span className="text-danger">*</span></Form.Label>
                      <Col sm={9}>
                    <DatePicker
    selected={workingDate ? new Date(workingDate) : null}
    onChange={(date) => {
        setWorkingDate(date ? formatLocalDate(date) : "");
        setErrors((p) => ({ ...p, workingDate: "" }));
    }}
    onChangeRaw={(e) => {
        const value = e.target.value;
        if (value && !/^[0-9/]*$/.test(value)) {
            e.preventDefault();
        }
    }}
    minDate={new Date()}
    dateFormat="dd/MM/yyyy"
    className="form-control"
    wrapperClassName="d-block"
    placeholderText="dd/mm/yyyy"
    disabled={isEditMode}
/>
                        <Form.Text muted>Must be a configured holiday or your week-off day.</Form.Text>
                        {errors.workingDate && <p style={errStyle}>{errors.workingDate}</p>}
                      </Col>
                    </Row>
                  </Col>
                  <Col md={6}>
                    <Row className="mb-3">
                      <Form.Label className="col-sm-3 col-form-label form-label">Upload Document</Form.Label>
                      <Col sm={9}>
                        <Form.Control type="file" id="compDocumentUpload" accept=".pdf,.jpg,.jpeg,.png" onChange={handleDocumentChange} />
                        <small className="text-muted d-block mt-1">Accepted: PDF, JPG, PNG (Max 1MB)</small>
                        {existingDocumentName && !documentFile && (
                          <div className="mt-2 p-2 bg-light border rounded d-flex justify-content-between align-items-center">
                            <span
                              className="text-success"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleViewDocument(editId)}
                            >
                              <i className="bi bi-file-earmark-check me-2" />{existingDocumentName}
                            </span>
                          </div>
                        )}
                        {documentPreview && (
                          <div className="mt-2 p-2 bg-light border rounded d-flex justify-content-between align-items-center">
                            <span style={{ color: "#2E5CB8" }}><i className="bi bi-file-earmark-arrow-up me-2" />{documentPreview}</span>
                            <Button variant="link" size="sm" className="text-danger p-0" onClick={handleRemoveDocument}><i className="bi bi-x-circle" /></Button>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <Row className="mb-3">
                      <Form.Label className="col-sm-2 col-form-label form-label">Work Details<span className="text-danger">*</span></Form.Label>
                      <Col sm={10}>
                        <Form.Control as="textarea" rows={3} maxLength={500} placeholder="Describe the work you did on this holiday/week-off"
    value={workDetails}
    onChange={(e) => {
        const value = e.target.value;
        setWorkDetails(value);
        const trimmedValue = value.trim();
        const isOnlyNumeric = /^\d+$/.test(trimmedValue);
        setErrors((p) => ({
            ...p,
            workDetails: isOnlyNumeric ? "Work details cannot be only numeric." : "",
        }));
    }} />
                        <div className="d-flex justify-content-between">
                          {errors.workDetails ? <p style={errStyle}>{errors.workDetails}</p> : <span />}
                          <small className="text-muted">{workDetails.length}/500</small>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col className="mt-2 d-flex align-items-center justify-content-center">
                    <Button variant="primary" type="submit" style={{ backgroundColor: "#2E5CB8", borderColor: "#2E5CB8" }} disabled={isSubmitting}>
                      {isSubmitting ? (isEditMode ? "Updating..." : "Submitting...") : (isEditMode ? "Update" : "Submit")}
                    </Button>
                    <Button variant="secondary" type="button" style={{ marginLeft: 10 }} onClick={handleCancel}>Cancel</Button>
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col xl={12}>
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Compensatory Leave Requests</h5>
              <i
                className="bi bi-download"
                title="Export CSV"
                style={{ fontSize: "1.3rem", cursor: "pointer", color: "#2E5CB8" }}
                onClick={handleExportCSV}
              />
            </Card.Header>
            <Card.Body>
              <Row className="mb-3 justify-content-end align-items-center g-2">
                <Col xs="auto">
                  <Form.Control placeholder="Search by date / work details..." value={searchQuery} onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }} style={{ width: 260 }} />
                </Col>
                <Col xs="auto">
                  <Form.Select value={statusFilter} onChange={(e) => { setStatusFilter(e.target.value); setCurrentPage(1); }} style={{ width: 140 }}>
                    <option value="all">All Status</option>
                    <option value="PENDING">Pending</option>
                    <option value="APPROVED">Approved</option>
                    <option value="REJECTED">Rejected</option>
                  </Form.Select>
                </Col>
                <Col xs="auto">
                  <Form.Select value={sortField} onChange={(e) => setSortField(e.target.value)} style={{ width: 180 }}>
                    <option value="applyDate">Sort: Latest First</option>
                    <option value="workingDate">Sort: Working Date</option>
                    <option value="status">Sort: Status</option>
                  </Form.Select>
                </Col>
                <Col xs="auto"><Badge bg="secondary">Total: {filteredData.length}</Badge></Col>
              </Row>

              <Table bordered hover responsive>
                <thead>
                  <tr>
                    {["Sr.No", "Working Date", "Applied On", "Work Details", "Document", "Status", "Action"].map((h) => (
                      <th key={h} style={{ backgroundColor: "#2E5CB8", color: "white" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {isLoading && <tr><td colSpan={7} className="text-center py-4"><div className="text-muted">Loading...</div></td></tr>}
                  {!isLoading && paginated.length === 0 && (
                    <tr><td colSpan={7} className="text-center py-4"><div className="text-muted">No compensatory leave requests found</div></td></tr>
                  )}
                  {!isLoading && paginated.map((app, index) => (
                    <tr key={app.id}>
                      <td>{(currentPage - 1) * ITEMS_PER_PAGE + index + 1}</td>
                      <td>{fmtDate(app.workingDate)}</td>
<td>{fmtDate(app.applyDate)}</td>
<td style={{ maxWidth: 260 }}>
  <div className="d-flex align-items-center">
    <span
      style={{ minWidth: 0, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}
      title={app.workDetails}
    >
      {app.workDetails}
    </span>
    {app.workDetails && app.workDetails.length > 30 && (
      <Button
        variant="link"
        size="sm"
        className="p-0 ms-1 text-danger"
        style={{ fontSize: 13, textDecoration: "none", whiteSpace: "nowrap" }}
        onClick={() => { setWorkDetailsText(app.workDetails); setShowWorkModal(true); }}
      >
        more
      </Button>
    )}
  </div>
</td>                      <td>
                        {app.documentName ? (
                          <Button variant="link" size="sm" className="p-0" onClick={() => handleViewDocument(app.id)}>
                            <i className="bi bi-file-earmark-text fs-5" style={{ color: "#2E5CB8" }} />
                          </Button>
                        ) : "—"}
                      </td>
                      <td>{getStatusBadge(app.status)}</td>
                      <td>
                        {app.status === "PENDING" ? (
                          <button className="btn btn-secondary" type="button" style={{ padding: "3px 8px", fontSize: 12 }} onClick={() => handleEdit(app)}>
                            <i className="bi bi-pencil-fill me-1" />Edit
                          </button>
                        ) : <span className="text-muted">—</span>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              {totalPages > 1 && (
                <div className="d-flex justify-content-end">
                  <Pagination>
                    <Pagination.Prev onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))} disabled={currentPage === 1} />
                    {[...Array(totalPages).keys()].map((n) => (
                      <Pagination.Item key={n + 1} active={n + 1 === currentPage} onClick={() => setCurrentPage(n + 1)}>{n + 1}</Pagination.Item>
                    ))}
                    <Pagination.Next onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages} />
                  </Pagination>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Modal show={showEditWarningModal} onHide={() => setShowEditWarningModal(false)} centered>
        <Modal.Header closeButton><Modal.Title><i className="bi bi-exclamation-triangle-fill text-warning me-2" />Cannot Edit Request</Modal.Title></Modal.Header>
        <Modal.Body>
          <p>This compensatory leave request is currently <strong>{pendingEditApplication?.status}</strong>.</p>
          <p className="mb-0 text-muted">Only <strong>PENDING</strong> requests can be edited.</p>
        </Modal.Body>
        <Modal.Footer><Button style={{ backgroundColor: "#2E5CB8", borderColor: "#2E5CB8" }} onClick={() => { setShowEditWarningModal(false); setPendingEditApplication(null); }}>OK</Button></Modal.Footer>
      </Modal>

      <Modal show={showWorkModal} onHide={() => setShowWorkModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Work Details</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", maxHeight: "60vh", overflowY: "auto" }}>
          {workDetailsText}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={() => setShowWorkModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDocModal} onHide={closeDocModal} size="lg" centered>
        <Modal.Header closeButton><Modal.Title><i className="bi bi-file-earmark-text me-2" />Document Viewer</Modal.Title></Modal.Header>
        <Modal.Body style={{ maxHeight: "70vh", overflow: "auto", display: "flex", alignItems: "center", justifyContent: "center" }}>
          {docUrl && (docType.startsWith("image/") ? (
            <img src={docUrl} alt="Document" style={{ maxWidth: "100%", maxHeight: "60vh", objectFit: "contain" }} />
          ) : (
            <iframe src={docUrl} style={{ width: "100%", height: "60vh", border: "none" }} title="Document Viewer" />
          ))}
        </Modal.Body>
        <Modal.Footer><Button variant="secondary" onClick={closeDocModal}>Close</Button></Modal.Footer>
      </Modal>
    </Container>
  );
};

export default CompensatoryLeaveRequest;